import React from "react";
import { isDevelopment } from "@utils/helpers/environment";
import { ProgressionBar } from "./progressionBar";
import { useSelector } from "react-redux";

function getStepByStepNumber(steps, stepNumber) {
  return steps.filter(step => step.step === stepNumber)[0];
}

const getPercentThrough = (stepNumber, steps, isFormCompleted) => {
  if (isFormCompleted) {
    return 100;
  }
  
  const activeStepObject = getStepByStepNumber(steps, stepNumber);
  const { percentComplete } = activeStepObject || {percentComplete: 0};
  
  return percentComplete;
}

export const BreadCrumb = ({ steps, activeStep, changeStep }) => {
  const safeSteps = steps || [];
  const { isFormCompleted } = useSelector(state => state.loanForm);

  const changeStepOnClick = () => {
    if(isDevelopment()) {
      const nextStep = activeStep + 1;
      if (nextStep > safeSteps.length) {
        changeStep(getStepByStepNumber(safeSteps, 1));
      } else {
        changeStep(getStepByStepNumber(safeSteps, nextStep));
      }
    }
  };
  
  return (
    <ProgressionBar onClick={changeStepOnClick} percent={getPercentThrough(activeStep, safeSteps, isFormCompleted)} activeStep={activeStep}/>
  );
};